import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";

import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";

import { useDispatch } from "react-redux";

const SecretResourceFormStepOne = (props) => {
  const { update } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { values, form } = props;

  // useEffect(() => {
  //   const fetchData = async () => {};
  //   fetchData();
  // }, []);

  return (
    <div className="SecretFormStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:secret.secretResourceInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            name="systemName"
            component={BMXTextField}
            label={t("global:secret.systemName")}
          />
        </Col>
        <Col xs={12}>
          <Field
            name="credentials"
            component={BMXTextField}
            label={t("global:secret.credentials")}
          />
        </Col>
        <Col xs={12}>
          <Field
            name="additionalNotes"
            component={BMXTextField}
            label={t("global:secret.additionalNotes")}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SecretResourceFormStepOne;
